import '../../style/index.less';
import './index.less';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_antd@3.9.2@antd/es/breadcrumb/style/index.js
// module id = Tyig
// module chunks = 15 16 17 20 21 28 41 42 43 44 45 46 47 48